import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './InstrumentDetailsPage.css';
import { getSetById } from './surgicalSetsData';

export default function SurgicalSetDetailsPage() {
  const { id } = useParams();
  const set = getSetById(id);

  if (!set) {
    return (
      <section className="instrument-details" style={{ paddingTop: 100 }}>
        <div className="container" style={{ maxWidth: 900, margin: '0 auto' }}>
          <h2>Set Not Found</h2>
          <p>We couldn't find details for this surgical set.</p>
          <Link to="/surgical-sets" className="btn btn-primary">Back to Surgical Sets</Link>
        </div>
      </section>
    );
  }

  const handleImageError = (e) => {
    e.target.alt = 'Image not available';
    e.target.style.opacity = '0.2';
    e.target.style.background = '#eee';
    e.target.src = 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="480" height="360"><rect width="100%" height="100%" fill="#f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#9ca3af" font-family="Arial" font-size="16">Image not available</text></svg>';
  };

  return (
    <section className="instrument-details section">
      <div className="container" style={{ maxWidth: 1100 }}>
        <Link to="/surgical-sets" className="breadcrumb-link">&larr; Back to Surgical Sets</Link>
        <div className="details-grid">
          <div className="details-card">
            <div className="details-image">
              <img src={set.image} alt={set.name} onError={handleImageError} />
            </div>
          </div>
          <div className="details-card details-content">
            <div className="details-header">
              <h2>{set.name}</h2>
              <span className="details-badge">Surgical Set</span>
            </div>
            {set.description && (
              <p className="details-description">{set.description}</p>
            )}

            {Array.isArray(set.items) && set.items.length > 0 && (
              <div className="spec-section">
                <h3>Included Instruments</h3>
                <ul style={{ paddingLeft: 18, margin: 0 }}>
                  {set.items.map((item, idx) => (
                    <li key={idx} style={{ marginBottom: 6 }}>{item}</li>
                  ))}
                </ul>
              </div>
            )}

            <div className="details-actions">
              <Link to="/#contact" className="btn btn-primary">Request a Quote</Link>
              <Link to="/surgical-sets" className="btn btn-outline">Back to Surgical Sets</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}